<template>
    <div class="cc-payment" v-if="display" @click="setPayment(payment)">
        <div class="cc-payment__selector">
            <div class="cc-selector cc-selector--medium cc-selector--radio" v-bind:class="{'cc-active': selected}"></div>
        </div>
        <div class="cc-payment__thumbnail" v-if="thumbnail">
            <img :src="thumbnail" :alt="payment.title" class="cc-payment__image"/>
        </div>
        <div class="cc-payment__information" v-bind:class="{'cc-thumbnail-exists': thumbnail}">
            <div class="cc-payment__title cc-title cc-title--payment">{{ payment.title }}</div>
        </div>
        <div class="cc-payment__prices">
            <div class="cc-price cc-price--payment">{{ price }}</div>
        </div>

    </div>
</template>

<script>
    import {mapState} from 'vuex';

    export default {
        computed: {
            ...mapState({
                translations: state => state.translations,
                selectedPayment: state => state.selectedPayment,
                useVat: state => state.config.use_vat,
                thumbnails: state => state.paymentMethodThumbnails,
            }),
            display: function () {
                return (!this.selectedPayment || this.selected) && this.payment.active === true;
            },
            selected: function () {
                return this.payment.uniqueName === this.selectedPayment;
            },
            thumbnail: function () {
                if (this.payment.name === 'pms_gopay_extra') {
                  let classList = this.payment.linkElement.classList;
                  if (classList.contains('PAYMENT_CARD')) {
                    classList.remove('PAYMENT_CARD');
                  }
                  let typeName = classList.toString().trim();
                    if (typeName) {
                        let computedStyle = getComputedStyle(document.querySelector('a.'+typeName));
                        let propertyValue = computedStyle.getPropertyValue('background-image');
                        let url = propertyValue.slice(4, -1).replace(/"/g, "");
                        return url;
                    }
                }
                if (this.payment.name in this.thumbnails) {
                    return this.thumbnails[this.payment.name];
                }

                return this.payment.img;
            },
            price: function () {
              if (this.payment.free) {
                return this.translations['Free'];
              }
              if (this.useVat) {
                return this.payment.formattedPrices.price;
              }
              return this.payment.formattedPrices.price_without_tax;
            },
        },
        methods: {
            setPayment: function (payment) {
                this.$store.dispatch('SELECT_PAYMENT', payment.uniqueName).then(function () {
                    if (typeof $.uniform !== 'undefined') {
                        $('input[type=checkbox]').uniform();
                    }

                    if (window.innerWidth < 1200) {
                        document.querySelector('.cc-payments').scrollIntoView({
                            behavior: "smooth",
                            block: "start",
                        });
                    } else {
                        document.querySelector('.cc-theme').scrollIntoView({
                            behavior: "smooth",
                            block: "start",
                        });
                    }
                });
            },
        },
        props: [
            'payment',
        ],
    };
</script>

<style lang="scss" scoped="scoped">
    @import "./scss/components/payment";
</style>
